function WorkingHoursNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="workinghours-tab">
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.5 3.333V1.666m0 1.667V5m0-1.667H8.75m-6.25 5v7.5c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667v-7.5h-15z"
      ></path>
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2.5 8.334V5c0-.92.746-1.667 1.667-1.667h1.666M5.833 1.667V5M17.5 8.334V5c0-.92-.746-1.667-1.667-1.667h-.416"
      ></path>
    </svg>
  );
}

export default WorkingHoursNavIcon;
